import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { SettingBtn } from '@components/index';
import { Info } from '@components';
import { useSelector, useDispatch } from 'react-redux';
import ProjectTag from '@components/projectCard/Tag';
import { setSessionStorage } from '@utils/windowUtil';
import { isEmailVerifiedOrBypassed } from '@utils/emailVerificationBypass';
import actions from '@flux/action';
import { isEmailVerifiedForUi } from '@utils/emailVerificationGate';

export default function ProjectTile({
  data = {},
  customizeHomeBtn = null,
  userInfo,
}) {
  const history = useHistory();
  const {
    projectName = '',
    targetName,
    buyerName,
    projectId,
    buyerIndustry,
    targetIndustry,
    confidential,
    isSingleCompany,
    companyInstance,
    instanceName,
    instanceIsDeleted,
  } = data;
  const isInternal = JSON.parse(
    window.localStorage.userInfo || '{}',
  ).isInternal;
  const dispatch = useDispatch();

  const emailVerModalRef = useSelector(
    (state) => state.common.emailVerModalRef,
  );
  const handleSetClick = (e) => {
    e.stopPropagation();
    if (projectId) {
      if (isEmailVerifiedOrBypassed(userInfo)) {
        setSessionStorage('projectName', projectName);
        setSessionStorage('currentId', projectId);
        history.push(`/projects/setting?projectId=${projectId}`);
      } else {
        emailVerModalRef &&
          emailVerModalRef.show &&
          emailVerModalRef.show({
            callback: () => {
              setSessionStorage('projectName', projectName);
              setSessionStorage('currentId', projectId);
              history.push(`/projects/setting?projectId=${projectId}`);
              dispatch(actions.getUserInfo);
            },
          });
      }
    }
  };

  const { buyerLabel, targetLabel } = useSelector(
    ({ common }) => common.projectCompanyInfo,
  );

  return (
    <div className="project-tile">
      <div className="project-name-wrapper" style={{ display: 'flex' }}>
        <span>{projectName}</span>
        {/*{!confidential && (*/}
        {/*  <ProjectTag*/}
        {/*    companyInstance={companyInstance}*/}
        {/*    type={instanceName}*/}
        {/*    shouldHide={instanceIsDeleted}*/}
        {/*  />*/}
        {/*)}*/}
      </div>
      {/*<div className="project-info">*/}
      {/*  <Info*/}
      {/*    type={buyerLabel}*/}
      {/*    data={buyerName}*/}
      {/*    industry={buyerIndustry}*/}
      {/*    confidential={confidential}*/}
      {/*    isInternal={isInternal}*/}
      {/*    getPopupContainer={() =>*/}
      {/*      document.getElementsByClassName('project-tile')[0]*/}
      {/*    }*/}
      {/*  />*/}
      {/*  {!isSingleCompany && (*/}
      {/*    <Info*/}
      {/*      type={targetLabel}*/}
      {/*      data={targetName}*/}
      {/*      industry={targetIndustry}*/}
      {/*      confidential={confidential}*/}
      {/*      isInternal={isInternal}*/}
      {/*      getPopupContainer={() =>*/}
      {/*        document.getElementsByClassName('project-tile')[0]*/}
      {/*      }*/}
      {/*    />*/}
      {/*  )}*/}
      {/*</div>*/}
      {isInternal && (
        <div className="setting-wrapper role-control">
          {/* <SettingBtn onClick={handleSetClick} /> */}
          {customizeHomeBtn}
        </div>
      )}
    </div>
  );
}
